import type { OidcConfig } from './oidc'

export function readSsoConfig(): OidcConfig {
  const issuer =
    (import.meta.env.VITE_AUTHENTIK_ISSUER_URL as string | undefined) ??
    'https://auth.staging.leadconnectorhq.com/application/o/internal-devtools'
  return {
    issuer,
    authorizationEndpoint:
      (import.meta.env.VITE_AUTHENTIK_AUTHORIZATION_ENDPOINT as string | undefined) ??
      'https://auth.staging.leadconnectorhq.com/application/o/authorize/',
    tokenEndpoint:
      (import.meta.env.VITE_AUTHENTIK_TOKEN_ENDPOINT as string | undefined) ??
      'https://auth.staging.leadconnectorhq.com/application/o/token/',
    userinfoEndpoint:
      (import.meta.env.VITE_AUTHENTIK_USERINFO_ENDPOINT as string | undefined) ??
      'https://auth.staging.leadconnectorhq.com/application/o/userinfo/',
    logoutEndpoint:
      (import.meta.env.VITE_AUTHENTIK_LOGOUT_ENDPOINT as string | undefined) ??
      'https://auth.staging.leadconnectorhq.com/application/o/internal-devtools/end-session/',
    clientId:
      (import.meta.env.VITE_AUTHENTIK_CLIENT_ID as string | undefined) ??
      'Ub3i5eaZ0fxJDsyvpvydBcDsl8CDnXoon7gEb5Yx',
    redirectUri:
      (import.meta.env.VITE_AUTHENTIK_REDIRECT_URI as string | undefined) ??
      `${window.location.origin}/login`,
    scope:
      (import.meta.env.VITE_AUTHENTIK_SCOPE as string | undefined) ??
      'openid profile email offline_access',
  }
}
